import React from "react";


const BankHubLayout = ({children, onChangeLanguage, language}) => {

    const handleClose = () => {
        document.getElementById("popup-alert-bankhub")
            .classList.add("hide")
        document.getElementById("popup-alert-bankhub")
            .classList.remove('show')
    }

    return (
        <div className="bankhub-container">
            {children}
            <div id="popup-alert-bankhub" className="popup hide">
                <div className="popup-wrapper">
                    <div className="bg"/>
                    <div className="popup-content">
                        <div id="popup-alert-bankhub-text">Có lỗi trong quá trình truy xuất dữ liệu sổ phụ.<br/> Vui lòng thử lại sau (Code #BH102-000217)</div>
                        <button onClick={() => handleClose()} className="btn-close-popup">Đóng</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BankHubLayout
